import { Link } from "react-router-dom";

export default function ErrorScreen({ generalError }) {
  const themeVars = {
    "--bg": "#0b0b0f",
    "--surface": "rgba(22, 22, 28, 0.75)",
    "--surface-2": "rgba(18, 18, 24, 0.6)",
    "--fg": "rgba(235,235,245,0.92)",
    "--muted": "rgba(235,235,245,0.6)",
    "--accent": "#f59e0b",
    "--accent-2": "#d97706",
  };

  return (
    <div
      className="relative min-h-dvh overflow-hidden antialiased"
      style={themeVars}
    >
      {/* Layered atmospheric background */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(1200px 600px at 80% 0%, rgba(245, 158, 11, 0.15), transparent 60%), radial-gradient(900px 500px at 20% 100%, rgba(217, 119, 6, 0.12), transparent 60%)",
          }}
        />
        <div className="absolute inset-0 bg-[linear-gradient(130deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:28px_28px] opacity-10" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(60% 60% at 50% 50%, rgba(0,0,0,0) 0%, rgba(0,0,0,0.45) 100%)",
          }}
        />
      </div>

      {/* Center stack */}
      <div className="relative z-10 flex min-h-dvh items-center justify-center px-4 sm:px-6">
        {/* If using framer-motion, replace this div with <motion.div initial={{ opacity: 0, y: 18, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }} className="w-full max-w-2xl"> */}
        <div className="w-full max-w-2xl">
          <div className="group relative rounded-3xl p-[1px]">
            <div
              className="absolute inset-0 rounded-3xl opacity-80 blur-md transition-opacity duration-700 group-hover:opacity-100"
              style={{
                background:
                  "conic-gradient(from 220deg at 50% 50%, rgba(245,158,11,.35), rgba(245,158,11,.05), rgba(245,158,11,.35))",
              }}
            />
            <div className="relative rounded-3xl bg-[var(--surface)] ring-1 ring-white/10 backdrop-blur-xl">
              {/* Header */}
              <div className="flex items-center gap-3 border-b border-white/10 px-6 py-4">
                <div className="size-2 rounded-full bg-[var(--accent)] shadow-[0_0_24px_rgba(245,158,11,.65)]" />
                <h1 className="text-xl font-semibold tracking-tight text-[var(--fg)]">
                  Something went wrong
                </h1>
              </div>

              {/* Body */}
              <div className="px-6 py-6 sm:px-8 sm:py-8">
                <p className="text-base leading-relaxed text-[var(--fg)]">
                  {generalError?.Error || "An unexpected error occurred."}
                </p>

                {/* {generalError?.ShowIMG & (
                  // With framer-motion: <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1, duration: 0.45 }} className="mt-6">
                  <div className="mt-6">
                    <img
                      src={noGood}
                      alt="Error illustration"
                      className="mx-auto h-56 w-auto rounded-2xl border border-white/10 bg-[var(--surface-2)] object-contain p-3 shadow-inner transition-transform duration-300 group-hover:scale-[1.01]"
                    />
                  </div>
                )} */}

                <div className="mt-8 flex flex-wrap items-center gap-3">
                  {generalError?.FixRoute ? (
                    <Link
                      to={generalError.FixRoute}
                      className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-[var(--surface-2)] px-4 py-2 text-sm font-medium text-[var(--fg)] shadow-sm outline-none transition-all duration-300 hover:-translate-y-0.5 hover:border-[var(--accent)] hover:shadow-[0_10px_30px_-12px_rgba(245,158,11,.45)] focus-visible:ring-2 focus-visible:ring-[var(--accent)]"
                    >
                      <span className="relative">
                        {generalError?.FixLabel || "Try again"}
                        <span className="absolute -bottom-1 left-0 h-[2px] w-full origin-left scale-x-0 bg-[var(--accent)] transition-transform duration-300 group-hover:scale-x-100" />
                      </span>
                    </Link>
                  ) : (
                    <Link
                      to="/"
                      className="text-sm text-[var(--muted)] underline decoration-dotted underline-offset-4 hover:text-[var(--accent)]"
                    >
                      Go back home
                    </Link>
                  )}

                  <span className="text-sm text-[var(--muted)]">
                    If this keeps happening, try refreshing the page or check
                    your connection.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </motion.div> */}
      </div>

      {/* Page-load flourish: accent bar (with motion, swap div -> motion.div) */}
      <div className="pointer-events-none absolute left-0 top-0 h-0.5 w-full origin-left bg-gradient-to-r from-[var(--accent)] via-transparent to-[var(--accent-2)] opacity-70" />
    </div>
  );
}
